import { AppState } from 'store'

export const projectDeliveryTermsCodeSelector = (state: AppState) => {
  return 'TODO: Implement projectDeliveryTermsCodeSelector'
}
